import { FormattedMessage } from 'react-intl';

import styles from './AuthForm.module.scss';

const CaptchaDisclaimer = () => (
  <span className={styles.recaptchaDisclaimer}>
    <FormattedMessage
      id="authScreen.captchaDisclaimer"
      defaultMessage="This site is protected by reCAPTCHA Enterprise and the Google <policyLink>Privacy Policy</policyLink> and <termsLink>Terms of Service</termsLink> apply."
      description="Disclaimer on sign up screen, where reCaptcha is used"
      values={{
        policyLink: (chunk) => (
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
            {chunk}
          </a>
        ),
        termsLink: (chunk) => (
          <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
            {chunk}
          </a>
        ),
      }}
    />
  </span>
);

export default CaptchaDisclaimer;
